import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["orderDateFrom", "orderDateTo"]
  // static targets = ["performButton", "orderDateFrom", "orderDateTo"]

  connect() {
    console.log("connected summary generator")
  }
  disconnect() {
    console.log("disconnected summary generator")
  }

  checkDates() {
  //   const from = this.orderDateFromTarget.value
  //   const to = this.orderDateToTarget.value

  //   if (from && to) {
  //     this.performButtonTarget.disabled = false
  //   } else {
  //     this.performButtonTarget.disabled = true
  //   }
  }

  perform() {
    const form = document.getElementById("orders-form")
    const originalAction = form.action
    const originalMethod = form.method

    form.action = "/orders/summary"
    form.method = "post"

    if (!form.querySelector('input[name="authenticity_token"]')) {
      console.log("ENTRENTNERNEENENEN")
      const token = document.querySelector('meta[name="csrf-token"]').getAttribute("content")
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "authenticity_token"
      input.value = token
      form.appendChild(input)
    }
    form.submit()
    form.action = originalAction
    form.method = originalMethod
  }
}